import { render, staticRenderFns } from "./ReferInfo.vue?vue&type=template&id=6adfbd58&scoped=true&"
import script from "./ReferInfo.vue?vue&type=script&lang=js&"
export * from "./ReferInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReferInfo.vue?vue&type=style&index=0&id=6adfbd58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adfbd58",
  null
  
)

export default component.exports